import React, { useEffect } from "react";
import { Box, Tabs, Tab, Typography, Button, Grid, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import Header from "../../Header";
import { useTranslation } from "react-i18next";
import MedicalStaff from "./MedicalStaff";
import Consultants from "./Consultants";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchHealthFacilities,
  fetchFosaFacilityUserSpecialties,
  fetchFosaFacilityUserPositions,
} from "../../action";

const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  paddingTop: ".6rem",
  paddingLeft: ".6rem",
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

const StyledTab = styled(Tab)(({ theme, selected }) => ({
  backgroundColor: selected ? "white" : "transparent",
  transition: theme.transitions.create("background-color", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.short,
  }),
  "&.Mui-selected": {
    backgroundColor: "white",
    borderRadius: ".2rem",
  },
}));

const StaffManagementPage = () => {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const SignInSuccess = useSelector((state) => state);
  const healthFacilityId =
    SignInSuccess?.profileReducer?.currentUserResponseData?.i_user
      ?.health_facility_id;

  const fosaHealthFacilitySpecialtyItems =
    SignInSuccess?.fosaReducer?.fosaHealthFacilitySpecialtyItems;
  const fosaHealthFacilityPositionItems =
    SignInSuccess?.fosaReducer?.fosaHealthFacilityPositionItems;

  useEffect(() => {
    if (!fosaHealthFacilitySpecialtyItems) {
      dispatch(fetchFosaFacilityUserSpecialties());
    }

    if (!fosaHealthFacilityPositionItems) {
      dispatch(fetchFosaFacilityUserPositions());
    }
  }, [
    dispatch,
    fosaHealthFacilityPositionItems,
    fosaHealthFacilitySpecialtyItems,
  ]);

  useEffect(() => {
    if (healthFacilityId) {
      dispatch(fetchHealthFacilities(healthFacilityId));
    }
  }, [healthFacilityId]);

  return (
    <Box>
      {/* <Grid container> */}
      <Header
        children={
          <Content>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="h5"
                sx={{
                  display: "flex",
                  fontWeight: "bold",
                }}
              >
                {t("staffTitle")}
              </Typography>
            </Box>
            <Grid
              container
              sx={{ display: "flex", flexDirection: "column", padding: 2 }}
            >
              <StyledPaperHeader>
                <StyledTabs
                  value={selectedTab}
                  onChange={handleChange}
                  aria-label="staff management tabs"
                >
                  <StyledTab label={t("MedicalStaff")} />
                  <StyledTab label={t("Consultants")} />
                  <StyledTab label={t("prestataires")} />
                </StyledTabs>
              </StyledPaperHeader>
              <Paper elevation={3} sx={{ padding: 2, marginTop: 2 }}>
                {selectedTab === 0 && <MedicalStaff />}
                {selectedTab === 1 && (
                  <Consultants
                    insuree_type="PRESTATAIRE"
                    newButtonLabel="newPrestataire"
                    editButtonLabel="updatePrestataire"
                  />
                )}
                {selectedTab === 2 && (
                  <Consultants
                    insuree_type="CONSULTANT"
                    newButtonLabel="newConsultant"
                    editButtonLabel="updateConsultant"
                  />
                )}
              </Paper>
            </Grid>
            {/* </Box> */}
          </Content>
        }
      />
    </Box>
  );
};

export default StaffManagementPage;
